import { createGlobalStyle } from "styled-components";
import { ThemeType } from "./type";
import { deviceSpec } from "breakpoints";

export const GlobalStyles = createGlobalStyle<{ theme: ThemeType }>`
  *, *::before, *::after {
    box-sizing: border-box;
  }

  html, body {
    margin: 0;
    padding: 0;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
  }

  p {
    font-size: 0.9rem;
  }

  body {
    background-color: ${({ theme }) => theme.colors.background};
  }
  
  // By default MUI selectors have a bizarre min-height
  .MuiSelect-select {
    min-height: 0 !important;
    margin: 0 5px !important;
  }

  .MuiButtonBaseRoot {
    height: 2rem;
  }

  .MuiFormControl-root {
    border: 1px solid ${({ theme }) => theme.colors.buttonBorder};
    border-radius: 0.5em;
  }

  .MuiFormControl-root:hover {
      border-color: ${({ theme }) => theme.colors.buttonBorderHighlight};
  }

  .MuiListItemIcon-root {
    min-width: min-content;
  }

  fieldset {
    border: none;
  }

  .fade {
    opacity: 0;
    transition: opacity 1s ease-in-out;
  }
  
  .fade.visible {
    opacity: 1;
  }
  
  .fade.hidden {
    opacity: 0;
  }

  .rs-picker-input-group {
    .rs-date-range-input, .rs-input-group-addon {
      align-self: center;
    }
    .rs-input-group-addon {
      margin: 0;
    }
  }

  .modal.fade .modal-dialog {
    transition: transform .3s ease-out;
    transform: translate(0, -50px);
  }

  #root {
    p, strong, h1, h2, h3, h4, h5, td, a, button, span, tspan {
      word-wrap: break-word;
      word-break: break-word;
      font-family: inherit;
      fill: #ffffff;
      letter-spacing: 0.01rem;
    }
  }

  #root {
    th {
      white-space: pre;
      font-size: 0.85rem;
      
      strong {
        font-size: 0.85rem;
      }
    }
    td {
      font-size: 0.75rem;
      strong {
        font-size: 0.75rem;
      }
    }
  }

  .fill-color {
    fill: ${({ theme }) => theme.colors.textColor};
  }

  button {
    box-shadow: none;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .fade-wrapper {
    mask-image: linear-gradient(to left, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 30%);
    -webkit-mask-image: linear-gradient(to left, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 30%);

    p {
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  .hide-for-small-screens {
    @media ${deviceSpec.isMobile} {
      display: none;
    }
  }
`;
